<template>
  <basic-layout-dynamic>
    <div class="container">
      <div class="contents">
        <div class="filter">
          <md-field>
            <md-textarea
              ref="text"
              :value="text"
              @input="updateText"
              placeholder="コードを改行区切りで入力してください"
            ></md-textarea>
          </md-field>
          <div class="actions">
            <div gl-tooltip="取得" gl-tooltip-direction="down">
              <gl-button
                primary
                @click="submit"
                :disabled="!canSubmit"
                icon-pre="search"
                icon-button
              ></gl-button>
            </div>
          </div>
        </div>
      </div>
      <div class="caution">
        <p>
          おまとめコードを連携しているかは御社システム管理者にお問い合わせください。
        </p>
      </div>
      <!-- 進捗ダイアログ -->
      <md-dialog
        :md-active.sync="downloading"
        :md-click-outside-to-close="false"
        :md-close-on-esc="false"
      >
        <md-dialog-content>
          <md-steppers
            md-alternative
            md-linear
            md-vertical
            :md-active-step.sync="activeStep"
          >
            <md-step
              id="creating"
              md-label="Create"
              :md-editable="false"
              :md-done.sync="completedSteps.creating"
            >
              <p>
                ファイルを作成しています
                <md-progress-bar md-mode="indeterminate"></md-progress-bar>
              </p>
            </md-step>
            <md-step
              id="download-ready"
              md-label="Done!"
              :md-editable="false"
              :md-done.sync="completedSteps.downloadReady"
            >
              <div class="md-layout-item md-layout md-gutter" v-if="!noData">
                <div class="md-layout-item" v-if="this.downloadStoreLink">
                  <a href="#" @click.prevent="downloadStore">店舗</a>
                </div>
                <div class="md-layout-item" v-if="this.downloadItemLink">
                  <a href="#" @click.prevent="downloadItem">商品</a>
                </div>
              </div>
              <p v-else>
                <span class="warn">対象データがありませんでした！</span>
              </p>
            </md-step>
          </md-steppers>
        </md-dialog-content>
        <md-dialog-actions v-if="canCloseDialog">
          <gl-button @click="downloading = false">Close</gl-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </basic-layout-dynamic>
</template>

<script>
/**
 * おまとめコード変換
 *
 * おまとめコードから店舗・商品へ変換しダウンロードさせる
 */
export default {
  props: {},
  data() {
    return {
      text: undefined,
      activeStep: 'creating',
      completedSteps: {
        creating: false,
        downloadReady: false,
      },
      downloading: false,
      downloadItemLink: undefined,
      downloadStoreLink: undefined,
      noData: false,
    }
  },
  computed: {
    canSubmit() {
      if (!this.text) {
        return false
      }
      return true
    },
    canCloseDialog() {
      return (
        this.activeStep === 'download-ready' || this.invalidFile || this.noData
      )
    },
  },
  methods: {
    /**
     * 入力テキスト変更
     */
    updateText(v) {
      this.text = v
    },
    async submit() {
      this.downloading = true
      this.noData = false
      this.completedSteps.creating = false
      this.completedSteps.finish = false
      this.activeStep = 'creating'
      this.downloadStoreLink = undefined
      this.downloadItemLink = undefined

      const codes = this.text
        .split('\n')
        .filter(v => v)
        .map(v => v.trim())
      const repo = this.$repositories.get('omatome')
      const result = await repo.get(codes)

      if (result[0]) {
        this.downloadStoreLink = result[0]
      }
      if (result[1]) {
        this.downloadItemLink = result[1]
      }

      if (!(this.downloadStoreLink || this.downloadItemLink)) {
        this.noData = true
      }

      this.completedSteps.creating = true
      this.completedSteps.downloadReady = true
      this.activeStep = 'download-ready'
    },
    downloadStore() {
      window.open(this.downloadStoreLink)
    },
    downloadItem() {
      window.open(this.downloadItemLink)
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.filter {
  align-items: center;
  display: flex;
  flex-direction: row;
}
.actions {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-left: var(--spacing-large);
}
.contents {
  width: auto;
  max-width: 1000px;
  padding-top: var(--spacing-large);
  padding-bottom: var(--spacing-large);
}
.file-name {
  font-size: 1.3rem;

  .icon {
    color: #00b0ff;
    margin-right: var(--spacing-small);
  }
}
.md-table-row {
  .customer-count {
    text-align: right;
  }
}
</style>
